// =============================================================================
// Copyright   : 2021 semantics GmbH
// Date        : $Date: 2022-11-15 18:20:46 +0100 (Tue, 15 Nov 2022) $
// Author      : Dirk Rothe, Tobias Schwarzkopf
// Worker      : $Author: d.rothe $
// Revision    : $Rev: 130658 $
// Purpose     : persistence layer sagas
// =============================================================================
// ---Third-party imports
import {select} from 'uix/sagas'
import {put, throttle} from 'redux-saga/effects'
import {openDb} from 'idb'

// ---Framework imports
import {get, dict, size, zip} from 'ldash'
import {Actions} from 'uix/registries'

import {isDebugOn} from 'uix/selectors'
import log from 'uix/logging'
// ---Local imports
import {getStoreNames, reset_tracker} from './utils'

// ---Globals
export function* clearLocalStorage() {
  let {dbName, storeName} = getStoreNames()
  yield new Promise((resolve, reject) => {
    openDb(dbName, 1)
      .then(db => {
        db.transaction(storeName, 'readwrite')
          .objectStore(storeName)
          .clear()
        resolve()
        reset_tracker()
      })
      .catch(err => log.error(err))
  })
  yield put(Actions.successNotification({header: 'Local settings deleted'}))
}

export function* getLocalStorageInfo() {
  let debugOn = yield select(isDebugOn)
  if (!debugOn || process.env.UIX_ENV === 'express') return

  let {dbName, storeName} = getStoreNames()
  // XXX: probably simpler with cps: https://github.com/redux-saga/redux-saga/issues/1406#issuecomment-382468916
  const promise = new Promise((resolve, reject) => {
    openDb(dbName, 1)
      .then(db => {
        let st = db.transaction(storeName).objectStore(storeName)
        st.getAll()
          .then(vals => {
            st.getAllKeys().then(keys => {
              let persistInfo = dict(zip(keys, vals).map(([k, v]) => [k, size(v)]))
              resolve({persistInfo})
            })
          })
          .catch(err => log.error(err))
      })
      .catch(err => log.error(err))
  })

  const {persistInfo} = yield promise
  yield put(Actions.setDebugData({persistInfo}))
}
